import React from 'react';
import { Box, FormControlLabel, Typography } from '@mui/material';
import StyledSwitch from './StyledSwitch';

const defaultFormControlLabelSx = {
  m: 0,
  width: 'fit-content',
  alignItems: 'center',
  gap: 0.75,
  '& .MuiFormControlLabel-label': {
    lineHeight: 1,
  },
};

const SwitchField = ({
  checked,
  onChange,
  label,
  helpText,
  compact = false,
  colorScheme = 'default',
  disabled = false,
  id,
  labelPlacement = 'end',
  containerSx,
  formControlLabelSx,
  switchProps,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      ...containerSx,
    }}
  >
    <FormControlLabel
      id={id}
      labelPlacement={labelPlacement}
      sx={{ ...defaultFormControlLabelSx, ...formControlLabelSx }}
      control={(
        <StyledSwitch
          compact={compact}
          colorScheme={colorScheme}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          {...switchProps}
        />
      )}
      label={label}
    />
    {helpText ? (
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
        {helpText}
      </Typography>
    ) : null}
  </Box>
);

export default SwitchField;
